module.exports = __webpack_public_path__ + "static/media/sfl_2.3e41a191.jpg";